export const visit = (vm, at) => {
at({ "de": { "ui-addon-video-player": { "havingTroubleWithVideoLink": "Wird das Video nicht richtig angezeigt?", "playButton": "Abspielen" } } });
};